import Product from './Product/Product';


const NotificationConfig = {
    settings: {
      layout: {},
    },
    routes: [
      {
        path: 'notification',
        element: <Product />,
      }
    ],
  };
  
  export default NotificationConfig;
